import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCol,{staticClass:"pa-0",staticStyle:{"border-style":"solid","border-width":"1px","border-color":"#00000030"},attrs:{"md":"6","sm":"12","xl":"3","lg":"3"}},[_c('div',{staticStyle:{"height":"250px","width":"250px","margin-left":"auto","margin-right":"auto"}},[_c('canvas',{ref:"chartCanvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }